var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSort({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 11.4 8.3",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "11.4,0 0,0 4.7,4.7 4.7,8.3 6.7,8.3 6.7,4.7 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSort);
export default __webpack_public_path__ + "static/media/icon_sort.08457ede70a56e77e015349c62623852.svg";
export { ForwardRef as ReactComponent };